@if (hasValidDisplay()) {
  @if (hasStackedLayout()) {
    <!-- Stacked layout: CODE (bold) + rocket icon / NAME (muted) below -->
    <!-- Mirrors the canonical CodeNameNavigationCellRendererComponent pattern -->
    <div class="text-content flex flex-col leading-tight">
      <!-- Code row: bold code + optional rocket icon -->
      <div class="flex items-center gap-1">
        <span class="nav-code-bold font-bold">{{ codeText() }}</span>
        @if (showIcon() && isNavigable()) {
          <mat-icon
            [svgIcon]="icon()"
            [class]="stackedIconClasses()"
            [matTooltip]="tooltipText()"
            matTooltipShowDelay="300"
            matTooltipPosition="above"
            (click)="isIconClickable() ? handleIconClick($event) : null"
            (auxclick)="isIconClickable() ? handleIconAuxClick($event) : null">
          </mat-icon>
        }
      </div>
      <!-- Name row: muted secondary text -->
      @if (nameText()) {
        <span class="font-descrip">{{ nameText() }}</span>
      }
    </div>
  } @else if (isNavigable()) {
    <!-- Flat navigable display with proper interaction handling -->
    <div
      [class]="containerClasses()"
      [matTooltip]="tooltipText()"
      matTooltipShowDelay="300"
      matTooltipPosition="above">

      <!-- Left positioned icon -->
      @if (showIcon() && iconPosition() === 'left') {
        <mat-icon
          [svgIcon]="icon()"
          [class]="iconClasses()"
          [ngClass]="{
            'cursor-pointer': isIconClickable(),
            'hover:text-blue-600': isIconClickable()
          }"
          [style.color]="'rgb(0, 0, 0)'"
          (click)="isIconClickable() ? handleIconClick($event) : null"
          (auxclick)="isIconClickable() ? handleIconAuxClick($event) : null">
        </mat-icon>
      }

      <!-- Text content -->
      @if (showText()) {
        <span
          [class]="textClasses()"
          [ngClass]="{
            'cursor-pointer': isTextClickable(),
            'underline': shouldUnderlineText(),
            'hover:text-blue-600': isTextClickable()
          }"
          (click)="isTextClickable() ? handleTextClick($event) : null"
          (auxclick)="isTextClickable() ? handleTextAuxClick($event) : null">
          {{ flatText() }}
        </span>
      }

      <!-- Right positioned icon -->
      @if (showIcon() && iconPosition() === 'right') {
        <mat-icon
          [svgIcon]="icon()"
          [class]="iconClasses()"
          [ngClass]="{
            'cursor-pointer': isIconClickable(),
            'hover:text-blue-600': isIconClickable()
          }"
          [style.color]="'rgb(0, 0, 0)'"
          (click)="isIconClickable() ? handleIconClick($event) : null"
          (auxclick)="isIconClickable() ? handleIconAuxClick($event) : null">
        </mat-icon>
      }
    </div>
  } @else {
    <!-- Plain (non-navigable) flat display: text ONLY, no rocket. -->
    <!-- A rocket implies navigation; when the record is not navigable we must -->
    <!-- not render it. Empty records fall through to the "-" placeholder. -->
    <div [class]="containerClasses()">
      @if (showText()) {
        <span [class]="textClasses()">
          {{ flatText() }}
        </span>
      }
    </div>
  }
} @else {
  <!-- Empty display fallback -->
  <span class="text-gray-400 text-sm">-</span>
}
